import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3suuhjvzxi: FaireBrandEntity = {
  token: "b_3suuhjvzxi",
  type: "brand",
  name: "Mavuno Harvest Organics",
  avatarUrl:
    "https://cdn.faire.com/fastly/955c1a29097c7f0107f683c048312b5ad8757836233d81c40134aad5fe2c6b66.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/6431a009b3ac96b1ffc604d9bb996c0cb67838df27c9c2c2e8881547c09adc6a.png",
  logoUrl:
    "https://cdn.faire.com/fastly/955c1a29097c7f0107f683c048312b5ad8757836233d81c40134aad5fe2c6b66.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6431a009b3ac96b1ffc604d9bb996c0cb67838df27c9c2c2e8881547c09adc6a.png",
  location: "Philadelphia, PA, USA",
  minimumOrderDollars: 139,
  rating: 4.9,
  reviewCount: 87,
  isTopShop: true,
  isInsider: true,
  description:
    "Mavuno Harvest was founded by a former Peace Corps volunteer with a simple but powerful mission: to support small farming communities around the world while bringing delicious, ethically sourced dried fruits to more people. By partnering directly with local drying facilities in Africa, South America, and South Asia, we transform surplus harvests into premium dried fruit — creating jobs, reducing food waste, and increasing farmer incomes.\n\nBut purpose alone isn’t why retailers choose Mavuno Harvest — performance is.\n\n#1 Fastest-Growing Brand in the nuts and fruit category in the natural channel, thanks to exceptional unit velocities.\n\nConsumer demand is shifting toward tropical fruits, and our lineup — including mango, pineapple, papaya, jackfruit, and more — leads the category.\n\nWe overperform our distribution, proving that once shoppers try Mavuno Harvest, they come back for more.\n\nOur brand is promoted twice as often as the industry average and delivers 3X more promotional efficiency, ensuring strong sell-through and repeat traffic.\n\nMavuno Harvest snacks are a natural fit for health-focused customers and a profitable choice for retailers. With options ranging from pure dried fruit to chocolate-dipped snacks and chewy fruit bites, we offer premium, clean-label products that deliver on both taste and values — and keep your shelves turning.\n\nEthically sourced. Naturally delicious. Profitable for your business.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:51:37.522Z",
    importedBy: "entity-db-cli",
  },
};
